import { render } from "./DashboardContentLayout.vue?vue&type=template&id=1fa8aa7a&ts=true"
import script from "./DashboardContentLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardContentLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__